/* global jQuery, elementorFrontend */

const sliderReviews = () => {
	(($) => {
		'use strict';

		const el = {
			swiper: {
				next: '.elementor-swiper-button-next',
				prev: '.elementor-swiper-button-prev',
			},
			custom: {
				next: '.mi-carousel--reviews__arrowNext',
				prev: '.mi-carousel--reviews__arrowPrev',
			},
		};

		const init = () => {
			exec();
		};

		const exec = () => {
			$(window).on('elementor/frontend/init', function () {
				elementorFrontend.hooks.addAction(
					'frontend/element_ready/template.default',
					function ($scope) {
						const $scoped_loop = $scope.find(
							'.elementor-widget.elementor-widget-loop-carousel',
						);

						if (
							$scoped_loop.length &&
							$scoped_loop.hasClass('mi-carousel--reviews') &&
							!$('.elementor-editor-active').length
						) {
							const $swiper_next = $scoped_loop.find(
								el.swiper.next,
							);
							const $swiper_prev = $scoped_loop.find(
								el.swiper.prev,
							);

							$swiper_next.hide();
							$swiper_prev.hide();

							$scoped_loop
								.closest('.e-con.e-parent')
								.find(el.custom.next)
								.on('click', function (event) {
									event.preventDefault();
									$swiper_next.trigger('click');
								});

							$scoped_loop
								.closest('.e-con.e-parent')
								.find(el.custom.prev)
								.on('click', function (event) {
									event.preventDefault();
									$swiper_prev.trigger('click');
								});
						}
					},
				);
			});
		};

		init();
	})(jQuery);
};

try {
	sliderReviews();
} catch (error) {
	console.error(error);
}
